export const CHECKOUT_URL = "https://sexcontrol-en.impultienda.ar/checkout/";

export const images = {
  mainMockup: "https://cdn.magicpatterns.com/uploads/pT1MaGFaPGgupEvS6db59j/SEXCONTROL-EN.png",
  creator: "https://cdn.magicpatterns.com/uploads/kmvTFGyRZQo1U5KuSEH7ij/ETHAN_COLE_-_SEXUAL_CONTROL.png",
};

export const beforeItems = [
  "You wait until your arousal is already extremely high.",
  "You struggle to recognize the early signals your body is giving you.",
  "You rely on willpower instead of a repeatable process.",
  "You become frustrated when things don’t go according to plan.",
  "You overthink what you’re supposed to do.",
  "You don’t have a consistent practice between intimate experiences.",
  "You wish you had more control and confidence.",
];

export const afterItems = [
  "You learn to recognize your personal arousal signals earlier.",
  "You practice simple breathing and awareness techniques.",
  "You develop a repeatable process for regulating rising arousal.",
  "You build greater awareness of your body instead of fighting against it.",
  "You track your progress over 28 days.",
  "You know exactly what to practice each day.",
  "You approach intimacy with a clearer, calmer mindset.",
];

export const painPoints = [
  { icon: "gauge", text: "You sometimes feel like your arousal rises faster than you can consciously manage." },
  { icon: "timer", text: "You want greater control during intimacy but don’t know exactly what to practice between experiences." },
  { icon: "help", text: "You’ve read advice before, but it never gave you a simple step-by-step system to follow." },
  { icon: "flame", text: "You become highly stimulated and wish you could recognize the warning signs earlier." },
  { icon: "brain", text: "You sometimes become anxious about whether you’ll be able to stay in control." },
  { icon: "shuffle", text: "You’ve tried random techniques but never followed a structured progression long enough to know what actually works for you." },
] as const;

export const volumes = [
  {
    number: "I",
    title: "The Control Foundation",
    tagline: "Understand the system before you start practicing it.",
    description:
      "I’ll show you how arousal works as a personal experience, how to identify your own signals, and how to establish your baseline before beginning the 28-day protocol.",
    items: ["Your Personal Control Baseline", "The Arousal Curve", "The 4 Control Zones", "Early Warning Signals", "Body Awareness Fundamentals", "The Control Loop™", "Your Personal Starting Score", "Common Beginner Mistakes"],
  },
  {
    number: "II",
    title: "The Body Awareness Method",
    tagline: "Learn to notice what your body is telling you before you need to react.",
    description:
      "Practical awareness exercises designed to help you become more familiar with tension, breathing, attention, sensation, and other signals that can accompany rising arousal.",
    items: ["Body Scan Method", "Tension Awareness", "Breathing Awareness", "Sensation Mapping", "Attention Training", "Relaxation Practice", "Personal Trigger Journal", "5-Minute Awareness Routine"],
  },
  {
    number: "III",
    title: "The Arousal Regulation Protocol",
    tagline: "Learn what to do when arousal starts rising.",
    description:
      "Instead of waiting until you’re overwhelmed, you’ll practice recognizing different stages and applying the appropriate response.",
    items: ["The 4-Zone Arousal Map™", "Regulation Breathing", "Attention Shifting", "Relaxation Protocol", "Reset Sequence", "Pause & Reassess Method", "Common Regulation Mistakes", "Your Personal Regulation Checklist"],
  },
  {
    number: "IV",
    title: "The 28-Day Control System",
    tagline: "Stop collecting information. Start building the skill.",
    description:
      "This is where everything comes together. A structured 28-day progression designed to move from awareness to regulation to practical integration.",
    items: ["28 Daily Missions", "Daily Practice Instructions", "Progress Scores", "Reflection Questions", "Weekly Checkpoints", "Difficulty Ratings", "Personal Notes", "Completion Tracker"],
  },
  {
    number: "V",
    title: "The Real-World Control Playbook",
    tagline: "Know exactly which protocol to use when you need it.",
    description:
      "Quick-reference protocols for different situations so you don’t have to remember everything you’ve learned.",
    items: ["Before-Intimacy Preparation", "Rising-Arousal Protocol", "Reset Protocol", "Breathing Protocol", "Focus Protocol", "Confidence Reset", "Post-Intimacy Reflection", "“What Should I Do Right Now?” Decision Guide", "Quick-Reference Cards"],
  },
  {
    number: "VI",
    title: "The Mastery & Maintenance System",
    tagline: "Build the skill into your lifestyle instead of starting over every few weeks.",
    description:
      "Once you’ve completed the first 28 days, you’ll have a clear path for continuing your practice.",
    items: ["Your 30-Day Maintenance Plan", "Advanced Practice Progression", "Weekly Control Check-In", "Personal Progress Dashboard", "Relapse-to-Routine Reset", "Confidence Building Exercises", "Long-Term Practice Calendar", "Your Personal Control Blueprint"],
  },
];

export const weeks = [
  { week: "Week 1", name: "Awareness", text: "Learn to recognize your body’s signals." },
  { week: "Week 2", name: "Regulation", text: "Practice slowing down and managing rising stimulation." },
  { week: "Week 3", name: "Control", text: "Build consistency and learn how to apply the tools deliberately." },
  { week: "Week 4", name: "Integration", text: "Turn the practices into a repeatable personal system." },
];

export const tools = [
  { icon: "loop", title: "The Control Loop™", text: "A simple visual framework showing you what to do from early awareness to regulation and reset." },
  { icon: "map", title: "The 4-Zone Arousal Map™", text: "A visual system for understanding your personal stages of rising arousal." },
  { icon: "tracker", title: "The 28-Day Progress Tracker", text: "Track your practice, awareness, confidence, consistency, and observations day by day." },
  { icon: "timer", title: "The 5-Minute Daily Practice System", text: "Simple exercises designed for days when you don’t have much time." },
  { icon: "journal", title: "The Personal Control Journal", text: "A private workbook for identifying patterns, triggers, progress, and areas for improvement." },
] as const;

export const bonuses = [
  {
    number: 1,
    title: "The 5-Minute Daily Reset™",
    value: 47,
    image: "https://cdn.magicpatterns.com/uploads/8HK1PayikCNFLaJXtMvfiK/BONUS_1_SEXCONTROL-EN.png",
    description: "A collection of short daily routines designed for busy days when you want to maintain your practice without spending a lot of time.",
    listLabel: "You’ll receive:",
    items: ["Morning Reset", "Evening Reset", "Focus Reset", "Tension Reset", "Pre-Intimacy Reset", "5-Minute Weekly Review"],
  },
  {
    number: 2,
    title: "The Arousal Map™ Quick-Reference Guide",
    value: 37,
    image: "https://cdn.magicpatterns.com/uploads/8DBsWMxCvKWQiQfG397W5J/BONUS_2_SEXCONTROL-EN.png",
    description: "A visual guide you can keep on your phone or print out. Learn how to identify the four zones of rising arousal and which type of response to practice at each stage.",
    listLabel: "Includes:",
    items: ["4-Zone Map", "Warning Signal Checklist", "Personal Signal Worksheet", "Quick Response Guide", "Printable Reference Card"],
  },
  {
    number: 3,
    title: "The 7-Day Confidence Reboot™",
    value: 47,
    image: "https://cdn.magicpatterns.com/uploads/k1P3wZB3TLux3MgsMK9xm9/BONUS_3_SEXCONTROL-EN.png",
    description: "A standalone 7-day mini-program designed to help you rebuild consistency and confidence after falling out of your routine. No complicated schedule — just one focused step per day.",
    listLabel: "Each day includes:",
    items: ["One short practice", "One awareness exercise", "One reflection", "One confidence-building action"],
  },
  {
    number: 4,
    title: "The Bedroom Control Quick Guide™",
    value: 37,
    image: "https://cdn.magicpatterns.com/uploads/rej9XMV1B992h4FnBQGa8t/BONUS_4_SEXCONTROL-EN.png",
    description: "A concise real-world reference guide covering preparation, awareness, breathing, regulation, communication, and post-intimacy reflection.",
    listLabel: "Designed to be:",
    items: ["Practical", "Private", "Easy to reference"],
  },
  {
    number: 5,
    title: "The 30-Day Private Progress Journal™",
    value: 29,
    image: "https://cdn.magicpatterns.com/uploads/etE5dCsAwai7jBwvkX9stp/BONUS_5_SEXCONTROL-EN.png",
    description: "A printable and digital journal. By the end, you’ll have your own personal record of what works best for you.",
    listLabel: "Track:",
    items: ["Practice consistency", "Body awareness", "Confidence", "Triggers", "Observations", "Progress", "Weekly reflections"],
  },
];

export const offerStack = [
  { label: "The Sexual Control Protocol™ — 6 Premium Volumes", value: 97 },
  { label: "5 Exclusive Bonuses", value: 197 },
  { label: "28-Day Guided Training System", value: 67 },
  { label: "Tracking & Personal Progress Tools", value: 37 },
];

export const testimonials = [
  {
    name: "Daniel R.",
    location: "Austin, TX",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/b253b515-4b60-484b-812c-fb8a9db1a9de.jpg",
    quote: "I had read a lot of information about sexual control before, but this was the first time I had an actual daily structure to follow. The 28-day format made it much easier to stay consistent.",
  },
  {
    name: "Marcus T.",
    location: "Atlanta, GA",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/eaab37ee-9bf5-4dca-b8ae-cb7382ca2058.jpg",
    quote: "The biggest difference for me was learning to pay attention to the early signals instead of waiting until I felt completely overwhelmed. The system gave me something practical to work on.",
  },
  {
    name: "Andrés M.",
    location: "Miami, FL",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/510ddabc-cc1d-4731-b39b-bd4aae38a3e0.jpg",
    quote: "It doesn’t feel like another book full of theory. Every section tells you what to practice and what to pay attention to.",
  },
];

export const faqs = [
  { q: "How will I receive the product?", a: "Immediately after your purchase, you’ll receive access instructions by email so you can download the digital volumes, bonuses, trackers, and worksheets." },
  { q: "Is this a video course?", a: "No. The Sexual Control Protocol™ is designed primarily as a structured digital training system and workbook, making it easy to read, practice, print, and revisit." },
  { q: "How long does the program take?", a: "The core system is structured around 28 days, with most daily practices designed to take approximately 5–15 minutes. You can move at your own pace." },
  { q: "Do I need a partner?", a: "No. Much of the system focuses on individual body awareness, breathing, attention, regulation, and personal practice." },
  { q: "Is this suitable for beginners?", a: "Yes. The system begins with foundational awareness and gradually progresses toward more practical applications. No previous experience with specialized practices is required." },
  { q: "Is this a medical treatment?", a: "No. The Sexual Control Protocol™ is an educational wellness product focused on body awareness, personal practice, confidence, and sexual self-regulation. It is not intended to diagnose, treat, cure, or prevent a medical condition. If you have persistent sexual, hormonal, pain-related, or other health concerns, speak with a qualified healthcare professional." },
  { q: "Can I use the material privately?", a: "Absolutely. The system is designed to be discreet and can be used digitally or printed for personal use." },
  { q: "Is this a subscription?", a: "No. It’s a one-time $27 purchase with lifetime access to the materials included with your purchase." },
  { q: "What if I don’t like it?", a: "You have a 7-day guarantee. Review the material and decide whether it’s right for you." },
  { q: "When will I get access?", a: "Immediately after successful payment." },
];

export const finalChecklist = ["6 Premium Volumes", "28-Day Training System", "5 Exclusive Bonuses", "Progress Trackers", "Quick-Reference Tools", "Lifetime Access", "7-Day Guarantee", "Immediate Digital Access"];

export const recentBuyers = [
  { name: "Carlos M.", country: "Mexico" },
  { name: "Javier R.", country: "Spain" },
  { name: "Andrés P.", country: "Colombia" },
  { name: "Diego F.", country: "Argentina" },
  { name: "Luis G.", country: "Peru" },
  { name: "Mateo S.", country: "Chile" },
  { name: "Alejandro V.", country: "Ecuador" },
  { name: "Santiago L.", country: "Uruguay" },
  { name: "José A.", country: "Dominican Republic" },
  { name: "Ricardo H.", country: "Costa Rica" },
  { name: "Fernando D.", country: "Guatemala" },
  { name: "Miguel Á.", country: "Puerto Rico" },
  { name: "Pablo C.", country: "Venezuela" },
  { name: "Gabriel N.", country: "Panama" },
  { name: "Tomás B.", country: "Bolivia" },
  { name: "Raúl E.", country: "Paraguay" },
];
